// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert_box{border-radius:10px;width:30%;text-align:center;overflow:inherit}.alert_box .modal-footer{padding:8px 6px}.alert_box button{padding:0 24px}.alert_box .alertInfo{font-size:14px;font-weight:500}.alert_box .modalClose{position:absolute;top:5px;right:5px;color:#000000}.alert_box .success_info{color:#0f9d58}.alert_box .error_info{color:darkred}\n", ""]);
// Exports
module.exports = exports;
